import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './WizardButtonGroup.module.scss'

const propTypes = {
  className: PropTypes.string
}

const WizardButtonGroup = ({ className, ...restProps }) => (
  <div className={classnames(styles.root, className)} {...restProps} />
)

WizardButtonGroup.propTypes = propTypes

export default WizardButtonGroup
